import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { InicioComponent } from './inicio/inicio.component';
import { CreacionusuariosComponent } from './creacionusuarios/creacionusuarios.component';
import { ModificausuarioComponent } from './modificausuario/modificausuario.component';
import { GestionMaestrasComponent } from './gestion-maestras/gestion-maestras.component';
import { AsignacionServiciosComponent } from './asignacion-servicios/asignacion-servicios.component';
import { ServiciosasignadosComponent } from './serviciosasignados/serviciosasignados.component';
import { AdministracionConductoresComponent } from './administracion-conductores/administracion-conductores.component';
import { AdministracionCausalesNoEntregaComponent } from './administracion-causales-no-entrega/administracion-causales-no-entrega.component';
import { AdministracionMotivoDevolucionComponent } from './administracion-motivo-devolucion/administracion-motivo-devolucion.component';
import { AdministracionEmpresaTransporteComponent } from './administracion-empresa-transporte/administracion-empresa-transporte.component';
import { AdministracionUsuarioWebComponent } from './administracion-usuario-web/administracion-usuario-web.component';
import { AdministracionMensajesComponent } from './administracion-mensajes/administracion-mensajes.component';
import { AdministracionAgenciaComponent } from './administracion-agencia/administracion-agencia.component';
import { AdministracionTiposNovedadesComponent } from './administracion-tipos-novedades/administracion-tipos-novedades.component';
import { AdministracionMotivosComponent } from './administracion-motivos/administracion-motivos.component';
import { AsignacionTransportadorAgenciaComponent } from './asignacion-transportador-agencia/asignacion-transportador-agencia.component';
import { AsignacionTransportadorVehiculoComponent } from './asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component';
import { EntregasTransportadorComponent } from './entregas-transportador/entregas-transportador.component';
import { CarguesUsuarioComponent } from './cargues-usuario/cargues-usuario.component';

import { EntregasCompletasComponent } from './entregas-completas/entregas-completas.component';
import { EntregasParcialesComponent } from './entregas-parciales/entregas-parciales.component';
import { EntregasComponent } from './entregas/entregas.component';
import { TiemposRutasComponent } from './tiempos-rutas/tiempos-rutas.component';
import { RutaEntregasComponent } from './ruta-entregas/ruta-entregas.component';
import { UbicacionComponent } from './ubicacion/ubicacion.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'inicio', component: InicioComponent, data: { title: 'Nuevo' } },
  {
    path: 'creacionusuarios',
    component: CreacionusuariosComponent,
    data: { title: 'Nuevo' }
  },
  {
    path: 'modificausuario',
    component: ModificausuarioComponent,
    data: { title: 'Nuevo' }
  },
  {
    path: 'gestionmaestras',
    component: GestionMaestrasComponent,
    data: { title: 'Nuevo' }
  }
  ,
  {
    path: 'asignacionservicios',
    component: AsignacionServiciosComponent,
    data: { title: 'Nuevo' }
  },
  {
    path: 'serviciosasignados',
    component: ServiciosasignadosComponent,
    data: { title: 'Servicios Asignados' }
  },
  {
    path: 'administracionconductores',
    component: AdministracionConductoresComponent,
    data: { title: 'Administracion Conductores' }
  },
  {
    path: 'administracioncausalesnoentrega',
    component: AdministracionCausalesNoEntregaComponent,
    data: { title: 'Administracion Causales No Entrega' }
  },
  {
    path: 'administracionmotivodevolucion',
    component: AdministracionMotivoDevolucionComponent,
    data: { title: 'Administracion Motivos Devolucion' }
  },
  {
    path: 'administracionempresatransporte',
    component: AdministracionEmpresaTransporteComponent,
    data: { title: 'Administracion Empresas Transporte' }
  },
  {
    path: 'administracionusuariosweb',
    component: AdministracionUsuarioWebComponent,
    data: { title: 'Administracion Usuarios Web' }
  },
  {
    path: 'administracionmensajes',
    component: AdministracionMensajesComponent,
    data: { title: 'Administracion Mensajes' }
  },
  {
    path: 'administracionagencia',
    component: AdministracionAgenciaComponent,
    data: { title: 'Administracion Mensajes' }
  },
  {
    path: 'asignaciontransportadoragencia',
    component: AsignacionTransportadorAgenciaComponent,
    data: { title: 'Administracion Mensajes' }
  },
    {
    path: 'asignaciontransportadorvehiculo',
    component: AsignacionTransportadorVehiculoComponent,
    data: { title: 'Administracion Mensajes' }
  },
  {
    path: 'administraciontiposnovedades',
    component: AdministracionTiposNovedadesComponent,
    data: { title: 'Administracion Tipos Novedades' }
  },
  {
    path: 'administracionmotivos',
    component: AdministracionMotivosComponent,
    data: { title: 'Administracion Motivos' }
  },
  {
    path: 'entregascompletas',
    component: EntregasCompletasComponent,
    data: { title: 'Entregas Completas' }
  },
  {
    path: 'entregasparciales',
    component: EntregasParcialesComponent,
    data: { title: 'Entregas Parciales' }
  },
  {
    path: 'entregas',
    component: EntregasComponent,
    data: { title: 'Entregas' }
  },
  {
    path: 'entregastransportador',
    component: EntregasTransportadorComponent,
    data: { title: 'Entregas Transportador' }
  },
  {
    path: 'carguexusuario',
    component: CarguesUsuarioComponent,
    data: { title: 'Cargues por usuario' }
  },
  {
    path: 'tiemporutas',
    component: TiemposRutasComponent,
    data: { title: 'Tiempo Rutas' }
  },
  {
    path: 'rutaentregas',
    component: RutaEntregasComponent,
    data: { title: 'Ruta Entregas' }
  },
  {
    path: 'ubicacion',
    component: UbicacionComponent,
    data: { title: 'Ubicacion' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
export const routingComponents = [
  LoginComponent,
  InicioComponent,
  CreacionusuariosComponent,
  ModificausuarioComponent,
  GestionMaestrasComponent,
  AsignacionServiciosComponent,
  AdministracionConductoresComponent,
  AdministracionCausalesNoEntregaComponent,
  AdministracionMotivoDevolucionComponent,
  AdministracionEmpresaTransporteComponent,
  AdministracionUsuarioWebComponent,
  AdministracionMensajesComponent,
  AdministracionAgenciaComponent,
  AsignacionTransportadorAgenciaComponent,
  AsignacionTransportadorVehiculoComponent,
  EntregasCompletasComponent,
  EntregasParcialesComponent,
  EntregasComponent,
  TiemposRutasComponent,
  RutaEntregasComponent,
  UbicacionComponent
];
